export default __webpack_public_path__ + "static/media/BQ-BO.af6920b9.svg";